import { camelCase } from 'lib/utils/objectSerializer';
import { MarketerAction } from './actions';
import {
  API_READ_ELIGIBILITY_ASSESSMENTS,
  API_READ_ELIGIBILITY_ASSESSMENTS_SUCCESS,
} from './actionTypes';
import { RestaurantAssessment } from './types';

export type MarketerState = {
  eligibilityAssessments: {
    byDrnId: Record<string, RestaurantAssessment>;
    all: string[];
    eligible: string[];
    ineligible: string[];
    areAllIneligible: boolean;
  };
};

const initialState = {
  eligibilityAssessments: {
    byDrnId: {},
    all: [],
    eligible: [],
    ineligible: [],
    areAllIneligible: false,
  },
};

export default function marketerReducer(
  state: MarketerState = initialState,
  action: MarketerAction,
): MarketerState {
  switch (action.type) {
    case API_READ_ELIGIBILITY_ASSESSMENTS:
      return {
        ...state,
        eligibilityAssessments: {
          ...initialState.eligibilityAssessments,
        },
      };

    case API_READ_ELIGIBILITY_ASSESSMENTS_SUCCESS: {
      const eligibilityAssesssments = camelCase(action.payload);

      const byDrnId: Record<string, RestaurantAssessment> = {};
      const all: string[] = [];
      const eligible: string[] = [];
      const ineligible: string[] = [];

      for (const restaurantAssesssment of eligibilityAssesssments) {
        byDrnId[restaurantAssesssment.restaurantDrnId] = restaurantAssesssment;

        all.push(restaurantAssesssment.restaurantDrnId);

        if (restaurantAssesssment.eligible) {
          eligible.push(restaurantAssesssment.restaurantDrnId);
        } else {
          ineligible.push(restaurantAssesssment.restaurantDrnId);
        }
      }

      return {
        ...state,
        eligibilityAssessments: {
          byDrnId,
          all,
          eligible,
          ineligible,
          areAllIneligible:
            ineligible.length > 0 && all.length === ineligible.length,
        },
      };
    }
    default:
      return state;
  }
}
